var map = {
	"./Belgrandiella bumasta.png": 128,
	"./Brachydesmus jalzici.png": 487,
	"./Brachythele kosovarica.jpg": 620,
	"./Bythinella istoka.png": 782,
	"./Drusus_dardanicus.jpg": 34,
	"./Drusus_sharrensis_.jpg": 879,
	"./Eratigena mirusha.png": 916,
	"./Harpacteae dardanica.jpg": 250,
	"./Nemesia dukagjinica.jpg": 59,
	"./Potamophylax coronavirus.jpg": 140,
	"./Potamophylax humoinsapiens.jpg": 820,
	"./Potamophylax kosovaensis.jpg": 806,
	"./Rhyacophila siparantum.jpg": 229,
	"./Terranigra kosovica.png": 979,
	"./Tinodes lumbardhi.jpg": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 357;